var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_066_denmark",
    "data-name": "066 denmark",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 14.985,
    cy: 14.85,
    rx: 14.985,
    ry: 14.85,
    transform: "translate(0.029 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M200.348,13.043H218.2A14.851,14.851,0,0,0,203.558,0a14.6,14.6,0,0,0-3.21.357V13.043h0Z",
    transform: "translate(-188.915)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M9.747,42.347V31.127a15.011,15.011,0,0,0-7.58,11.22h7.58Z",
    transform: "translate(-2.167 -29.303)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M9.747,289.391H2.167a15.01,15.01,0,0,0,7.58,11.22v-11.22Z",
    transform: "translate(-2.167 -272.434)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M200.348,289.391v12.687a14.6,14.6,0,0,0,3.21.357A14.851,14.851,0,0,0,218.2,289.391H200.348Z",
    transform: "translate(-188.915 -272.434)",
    fill: "#d80027"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDk);
export default __webpack_public_path__ + "static/media/DK.91021c41c0156f3a8543b135d443c744.svg";
export { ForwardRef as ReactComponent };